import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/ui/themes";

const appearance = {
  theme: dark,
  captcha: { theme: "dark" },
  variables: { colorPrimary: "#00ff72", colorPrimaryForeground: "#031109", colorBackground: "#0a1218", colorInput: "#071016", borderRadius: "2px", fontFamily: "'JetBrains Mono', monospace" },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Starts Clerk from the backend's runtime config, so deploy's live keys need no rebuild.
export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 8) setUnavailable(true);
      setTimeout(() => load(attempt + 1), attempt >= 8 ? 4000 : 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (!config) return <div className="boot-screen" data-testid="boot-screen"><span className="brand-mark">TZ</span><p>{unavailable ? "Reconnecting to the secure server — this usually takes a few seconds..." : "Initializing secure session..."}</p><i className="boot-bar"/>{unavailable && <button className="btn btn-ghost" onClick={() => window.location.reload()} data-testid="boot-retry-button">Retry now</button>}</div>;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/account"
      signUpFallbackRedirectUrl="/account"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
